import React, { SVGProps } from "react";

export default function SparkleIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12 24C12.3965 24 12.6862 23.7101 12.7623 23.2982C13.845 14.9371 15.019 13.6707 23.2833 12.7552C23.7103 12.7094 24 12.389 24 11.9924C24 11.5957 23.7103 11.2905 23.2833 11.2295C15.019 10.314 13.845 9.04765 12.7623 0.686593C12.6862 0.274649 12.3965 0 12 0C11.6035 0 11.3138 0.274649 11.2529 0.686593C10.1703 9.04765 8.98096 10.314 0.731829 11.2295C0.2897 11.2905 0 11.5957 0 11.9924C0 12.389 0.2897 12.7094 0.731829 12.7552C8.96567 13.8385 10.1092 14.9523 11.2529 23.2982C11.3138 23.7101 11.6035 24 12 24Z"
        fill="#55358F"
      />
    </svg>
  );
}
